import React from 'react';
import './SecurityStatusCard.css';

const SecurityStatusCard = ({ scanData }) => {
  const checks = scanData?.security_checks || {};
  
  const statusItems = [
    {
      key: 'malware',
      label: 'No malware detected by scan',
      status: checks.malware_detected === false ? 'safe' : 'unknown',
      risk: 'Low Risk'
    },
    {
      key: 'spam',
      label: 'No injected spam detected',
      status: checks.spam_detected === false ? 'safe' : 'unknown',
      risk: 'Low Risk'
    },
    {
      key: 'defacement',
      label: 'No defacements detected',
      status: checks.defacement_detected === false ? 'safe' : 'unknown',
      risk: 'Low Risk'
    },
    {
      key: 'server_errors',
      label: 'No internal server errors detected',
      status: checks.server_errors === false ? 'safe' : 'unknown',
      risk: 'Low Risk'
    },
    {
      key: 'outdated',
      label: 'Site is outdated',
      status: checks.site_outdated === true ? 'warning' : 'safe',
      risk: checks.site_outdated === true ? 'High Risk' : 'Low Risk'
    }
  ];

  const getStatusIcon = (status) => {
    if (status === 'safe') return '✓';
    if (status === 'warning') return '⚠';
    return '?';
  };

  const getStatusColor = (status) => {
    if (status === 'safe') return '#28a745';
    if (status === 'warning') return '#ffc107';
    return '#999';
  };

  return (
    <div className="security-status-card">
      <div className="card-header">
        <h3>Website Malware & Security</h3>
      </div>
      <div className="status-items">
        {statusItems.map((item) => (
          <div key={item.key} className="status-item">
            <div className="status-icon" style={{ color: getStatusColor(item.status) }}>
              {getStatusIcon(item.status)}
            </div>
            <div className="status-content">
              <div className="status-label">{item.label}</div>
              <div className="status-risk">{item.risk}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityStatusCard;

